<template>
  <div>
    <!-- search bar  -->
    <div class="sm:flex">
      <div class="relative mr-6 my-2 mb-4 lg:mb-7 w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <!-- desktop search input -->
        <input
            type="search"
            class="bg-white rounded p-2 hidden sm:block w-full"
            placeholder="Введите название команды"
            v-model="searchKeyword"
        />
        <!-- mobile search input -->
        <input
            type="search"
            class="bg-white shadow rounded p-2 sm:hidden w-full"
            placeholder="Введите название команды"
            v-model="searchKeyword"
        />
        <div class="absolute pin-t mr-6 h-full text-purple-lighter pin-r flex items-center">
          <img src="../../../assets/icons/search-icon.svg" alt="" class="h-4">
        </div>
      </div>
      <!-- filter desktop -->
      <div class="sm:ml-auto md:flex hidden filter pt-0 sm:pt-6" v-if="ratingTableType ==='general'">
        <img
            @click="ratingFilterModal = true"
            class="cursor-pointer"
            src="@/assets/icons/filter-icon.svg"
            alt
        />
        <p @click="ratingFilterModal = true" class="cursor-pointer">Фильтры</p>
      </div>
      <!-- filter mobile -->
      <div
          class="sm:ml-auto flex filter justify-end pt-0 sm:pt-6 md:hidden w-full"
          style="width:92%"
          v-if="ratingTableType ==='general'"
      >
        <img
            @click="ratingFilterModal = true"
            src="@/assets/icons/filter-icon.svg"
            alt
        />
        <p @click="ratingFilterModal = true">Фильтры</p>
      </div>
    </div>

    <!-- table for desktop -->
    <div class="table mx-auto w-full p-0">
      <table class="w-full font-bold relative mt-3 hidden md:table" v-if="filteredTeam.length !== 0">
        <thead class="text-xs">
        <tr>
          <th style="width:5%" v-if="ratingTableType == 'general'"><span>Место</span></th>
          <th style="width:10%" v-else><span class="ml-2">Место</span></th>
          <th v-if="ratingTableType == 'general'" style="width:5%"><span>Ранг</span></th>
          <th style="width:30%"><span>Команда</span></th>
          <th style="width:20%"><span>Город</span></th>
          <th style="width:15%"><span>Всего игр</span></th>
          <th style="width:15%"><span>Всего побед</span></th>
          <th style="width:10%"><span @click="changeSortDirection">Общий балл</span>
            <span>
              <img @click="axiosTable('score_sum', sort_direction, 1)" src="@/assets/SVG/sort.svg" alt="sort"
                   class="ml-2"/>
              </span>
          </th>
        </tr>
        </thead>

        <tbody style="height: 320px">
        <!-- spinner -->
        <div class="spinner" v-if="!spinner">
          <div
              class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-16 w-16"
          ></div>
        </div>
        <!-- table rows -->
        <div v-else>
          <MozgoTableItem
              v-for="(team, key) in filteredTeam"
              :key="key"
              :tableItem="team"
              :pageType="pageType"
              :tabNumber="key"
              :popoverText="pageType === 'tuts' ? '<p>Команда-участник<br> Королевского Туца</p>':'<p>Команда-участник<br> Лиги Чемпионов</p>'"
              :showCrownIcon="showCrownIcon && team.position === 1"
              :ratingTableType="ratingTableType"
              @showResultModal="initModal($event)"
          />
        </div>
        </tbody>
      </table>

      <!-- table for mobile -->
      <div class="md:hidden mt-8" v-if="filteredTeam.length !== 0">
        <!-- spinner -->
        <div class="spinner" v-if="!spinner">
          <div
              class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-16 w-16"
          ></div>
        </div>
        <table v-else style="width:100%" class="table-mobile md:hidden">
          <tr
              v-for="(team, key) in filteredTeam"
              :key="key"
              @click="ratingInfo(key, true)"
              :class="{'champion':team.highlighted}"
              class="flex"
          >

            <td class="flex items-start py-2 relative" style="width:25%">
              <!-- player position -->
              <p class="ml-3 w-8 mr-0 text-center" :class="{'pt-1':ratingTableType == 'general'}">{{
                  team.position
                }}</p>

              <div style="padding-top:2px" class="ml-auto mr-3" v-if="team.highlighted">

                <!-- show champion icon -->
                <img @mouseover="championsPrompt = true"
                     @mouseleave="championsPrompt = false"
                     :src="require(`@/assets/icons/${pageType==='tuts'?'crown-icon':'trophy'}.svg`)"
                     alt="">
              </div>

              <!-- player rank only for general !  -->
              <div style="padding-top:0px" class="ml-auto mr-0" v-if="ratingTableType == 'general'">

                       <span v-if="team.rang !== 'Без ранга' && team.rang">
                        <img :src="require(`@/assets/icons/${team.rang}.svg`)" alt="" class="-mb-2">
                       </span>
                <div v-else style="width:28px;height:28px"></div>
              </div>

            </td>


            <!-- team name -->
            <td class="items-start py-2" style="width:63%">
              <div>
                <p class="commander-name">{{ team.name }}</p>
                <p class="city-name">{{ team.city }}</p>
              </div>
            </td>
            <!-- points -->
            <td class="items-start py-2" style="width:17%;color: rgb(189, 0, 108);"><p>
              {{ Math.round(team.score_sum * 1e2) / 1e2 }}</p></td>
          </tr>
        </table>

        <!-- small modal to see rating info when user click  -->
        <showTeamRatingInfo
            v-if="ratingInfoModal"
            @close="ratingInfo(false)"
            :ratingInfo="true"
        >
          <div class="rating-info">
            <h1>Рейтинг</h1>
            <h3>{{ teams[teamIndex].name }}</h3>
            <p>{{ teams[teamIndex].city }}</p>
            <div v-if="ratingTableType == 'general'" class="all-game flex justify-between">
              <p>Ранг</p>
              <p>{{ teams[teamIndex].rang }}</p>
            </div>
            <div class="all-game flex justify-between">
              <p>Всего игр</p>
              <p>{{ teams[teamIndex].game_count }}</p>
            </div>
            <div class="all-win flex justify-between">
              <p>Всего побед</p>
              <p>{{ teams[teamIndex].win_count }}</p>
            </div>
            <div class="overall-score flex justify-between">
              <p>Общий балл</p>
              <p>{{ Math.round(teams[teamIndex].score_sum * 1e2) / 1e2 }}</p>
            </div>
          </div>
        </showTeamRatingInfo>
      </div>
      <!-- show this message to the user when there is no data in the rating table -->
      <div class="no-result-rating" v-if="filteredTeam.length === 0 && spinner === true ">
        <p>По вашему запросу ничего не найдено</p>
      </div>
    </div>
    <div
        class="w-full flex justify-center see-more"
        v-if="teams.length > showRows && searchKeyword === '' && showSeeMoreButton"
    >
      <button @click="showRowsMethod" v-if="teams.length - showRows >=10" class="hover-up">
        Загрузить еще 10 из {{ teams.length - showRows }}
      </button>

      <button @click="showRowsMethod" class="hover-up" v-else>
        Загрузить еще {{ teams.length - showRows }}
      </button>
    </div>

    <!-- filter modal -->
    <ratingFilterModal v-if="ratingFilterModal" @close="ratingFilterModal = false"></ratingFilterModal>
  </div>
</template>

<script>
import PopSelect from '@/views/home-page-layouts/components/PopSelect.vue';
import showTeamRatingInfo from '@/views/modals/base-modal-white.vue';
import ratingFilterModal from '@/views/modals/rating-filter-modal.vue';
import axios from 'axios';
import { mapActions } from 'vuex';
import MozgoTableItem from './MozgoTableItem.vue';

export default {
  name: 'MozgoTable',
  props: {
    ratingTableType: {
      type: String,
      default: 'general',
    },
    showCrownIcon: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: 'general',
    },
  },
  components: {
    PopSelect,
    MozgoTableItem,
    showTeamRatingInfo,
    ratingFilterModal,
  },
  data() {
    return {
      searchKeyword: '',
      spinner: false,
      ratingInfoModal: false,
      ratingFilterModal: false,
      showSeeMoreButton: true,
      teamIndex: 0,
      optionsArray: [
        {
          sort_type: 'name',
          sort_direction: 'desc',
        },
        {
          sort_type: 'name',
          sort_direction: 'asc',
        },
        {

          sort_type: 'city',
          sort_direction: 'desc',
        },
        {

          sort_type: 'city',
          sort_direction: 'asc',
        },
        {
          sort_type: 'game_count',
          sort_direction: 'desc',
        },
        {
          sort_type: 'game_count',
          sort_direction: 'asc',
        },
        {

          sort_type: 'win_count',
          sort_direction: 'desc',
        },
        {

          sort_type: 'win_count',
          sort_direction: 'asc',
        },
        {

          sort_type: 'score_sum',
          sort_direction: 'desc',
        },
        {

          sort_type: 'score_sum',
          sort_direction: 'asc',
        },
      ],
      teams: [],
      showRows: 10,
      sort_direction: 'asc',
      showResultModal: false,
      selectedTeam: {},
      base: process.env.VUE_APP_BACKEND,
    };
  },
  created() {
    this.axiosTable('position', this.sort_direction, 8);
    this.addCity({ id: this.cityId, name: this.city });
  },
  computed: {
    selectedCities() {
      return this.$store.state.ratingTable.selectedCities;
    },
    filteredTeam() {
      let filteredTeam = this.teams;
      if (
        this.searchKeyword === ''
      ) {
        filteredTeam = this.teams.slice(0, this.showRows);
      }
      return filteredTeam;
    },
    city() {
      return this.$store.getters.cityProps.city || '';
    },
    cityId() {
      return this.$store.getters.cityProps.id || '';
    },
  },
  methods: {
    ...mapActions([
      'addDefaultCitytoFilter',
    ]),
    // select city add to filter
    addCity(city) {
      this.addDefaultCitytoFilter(city);
    },
    initModal(ev) {
      this.selectedTeam = this.teams[ev.id];
      this.toggleResultModal();
    },
    toggleResultModal() {
      this.showResultModal = !this.showResultModal;
    },
    changeSortDirection() {
      this.sort_direction == 'asc' ? this.sort_direction = 'desc' : this.sort_direction = 'asc';
      this.axiosTable(this.sort_direction);
    },
    axiosTable() {
      this.spinner = false;

      // getting data for general
      if (this.ratingTableType === 'general') {
        const citiesId = [];

        if (this.selectedCities.length !== 0) {
          this.selectedCities.forEach((city) => {
            citiesId.push(city.id);
          });
        } else {
          citiesId.push(this.cityId);
        }
        // sort_type=position&sort_direction=${this.sort_direction}&name=${this.searchKeyword}&city=${citiesId}
        console.log(citiesId);
        axios
          .get(`${this.base}/results/test/all`, {
            params: {
              sort_type: 'position',
              city: citiesId.filter(i => i).length ? citiesId : undefined,
              sort_direction: this.sort_direction,
              name: this.searchKeyword,
              product_id: this.pageType === 'general' ? 1 : 3,
            },
          })
          .then(({ data }) => {
            this.teams = data;
            this.spinner = true;
          });


        // getting data for champions
      } else {
        axios
          .get(`${this.base}/results/new?city_id=${this.cityId}&sort_type=position&sort_direction=${this.sort_direction}&filter[name]=${this.searchKeyword}&filter[city_id]=${this.cityId}&product_id=${this.pageType === 'general' ? 1 : 3}`)
          .then(({ data }) => {
            this.teams = data;
            this.spinner = true;
          });
      }
    },
    // change show Rows to select how many rows shows in the table
    showRowsMethod() {
      if (this.teams.length > this.showRows) {
        this.showRows = this.showRows + 10;
      } else {
        this.showRows = this.teams.length;
      }
    },
    // open rating info modal to show team rating info
    ratingInfo(key, value) {
      this.teamIndex = key;
      if (value === true) {
        this.ratingInfoModal = true;
        document.body.classList.add('body-modal-open');
      } else {
        this.ratingInfoModal = false;
        document.body.classList.remove('body-modal-open');
      }
    },
  },
  watch: {
    ratingTableType() {
      this.axiosTable('score_sum', 'asc', 8);
      this.showRows = 10;
    },
    searchKeyword() {
      this.axiosTable('score_sum', 'asc', 8);
    },
    selectedCities() {
      this.axiosTable('score_sum', 'asc', 8);
    },
    filteredTeam() {
      this.showSeeMoreButton = true;
    },
  },
};
</script>

<style scoped>
input {
  border: 1px solid #DADADA;
  outline: none;
  padding-top: 22px;
  -webkit-appearance: none;
  background: white;
}

.filter img {
  height: 20px !important;
  margin-right: 10px;
}

.filter p {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  height: 20px;
}

.table {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  color: #333333;
  height: 400px;
}

.tour {
  width: 44px;
}

table {
  border-collapse: collapse;
  border-spacing: 0 10px;
}

.table-mobile tr {
  min-height: 52px;
}

.table-mobile td {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  border-bottom: 1px solid #dadada;
  color: #333333;
}

.table-mobile .commander-name {
  padding-bottom: 5px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #333333;
  width: 90%;
  margin-left: 10px;
  overflow-wrap: anywhere;
}

.table-mobile .city-name {
  width: 90%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 18px;
  color: #979797;
  margin-left: 10px;
}

.champion {
  background: rgba(255, 206, 66, 0.2);
}

tbody {
  max-height: 550px;
  /* overflow-y: scroll;
  display: block; */
  width: 100%;
}

thead tr,
tbody tr {
  display: table;
  width: 100%;
}

thead {
  border-bottom: 1px solid #979797;
}

th {
  text-align: start;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-right: 5px;
  white-space: nowrap;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  color: #979797;
  cursor: pointer;
}

::-webkit-scrollbar {
  background-color: transparent;
  width: 3px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(151, 151, 151, 0.2);

  border-radius: 16px;
  border: 5px solid transparent;

  transition: background-color 0.8s ease;
}

table:hover ::-webkit-scrollbar-thumb {
  background-color: rgba(151, 151, 151, 0.5);
}

.see-more {
  margin-top: 47px;
}

.see-more button {
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 45px;
  padding-top: 11px;
  padding-bottom: 11px;
  width: 290px;
  outline: none;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #333333;
}

/* spinner */
.spinner {
  display: grid;
  place-content: center;
  height: 500px;
}

.loader {
  border-top-color: #c92760;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

.rating-info {
  padding: 0 1.5rem 2.5rem 1.5rem;
  font-family: Montserrat;
  font-style: normal;
}

.rating-info h1 {
  position: absolute;
  top: 2rem;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #333333;
}

.rating-info h3 {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #333333;
}

.rating-info p {
  font-weight: normal;
  font-size: 8px;
  line-height: 10px;
  color: #979797;
}

.all-game {
  margin-top: 24px;
}

.all-game p,
.all-win p {
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: #333333;
}

.all-win {
  margin-top: 8px;
}

.overall-score {
  margin-top: 40px;
}

.overall-score p {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #bd006c;
}

.no-result-rating {
  height: 376px;
  width: 100%;
  display: grid;
  place-content: center;
}

.no-result-rating p {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #979797;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 767px) {
  .no-result-rating p {
    font-size: 12px;
    line-height: 15px;
  }
}


@media screen and (min-width: 300px) and (max-width: 800px) {
  .table {
    /* width: 300px !important; */
  }

  .team-name {
    width: 200px !important;
  }
}
</style>
